<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">
	  <el-form ref="update" :model="update" :rules="rules" label-width="100px" size="small">
	  	  <div class="backborder3">
	  	  	  <el-col :span="24">
	  	  	  	  <el-col :span="8">
	  	  	  	  	  <el-form-item label="仓库名称" prop="name">
		                  <el-input v-model="update.name"></el-input>
		              </el-form-item>
	  	  	  	  </el-col>
	  	  	  </el-col>
	  	  	  <el-col :span="24">
	  	  	  	  <el-col :span="8">
	  	  	  	  	  <el-form-item label="仓库编号" prop="number">
		                  <el-input v-model="update.number"></el-input>
		              </el-form-item>
	  	  	  	  </el-col>
	  	  	  </el-col>
	  	  	  <el-col :span="24">
	  	  	  	  <el-col :span="8">
	  	  	  	  	  <el-form-item label="负责人">
		                  <el-input v-model="update.contact"></el-input>
		              </el-form-item>
	  	  	  	  </el-col>
	  	  	  </el-col>
	  	  	  <el-col :span="24">
	  	  	  	  <el-col :span="8">
	  	  	  	  	  <el-form-item label="联系电话">
		                  <el-input v-model="update.phone"></el-input>
		              </el-form-item>
	  	  	  	  </el-col>
	  	  	  </el-col>
	  	  	  <el-col :span="24" style="margin-top:10px;text-align:right">
	  	  	  	  <el-form-item>
		              <el-button size="small" type="primary" :loading="updateLoading" @click="updateSave">保 存</el-button>
		          </el-form-item>
	  	  	  </el-col>
	  	  </div>
	  </el-form>
       
  </div>
  </transition>  
</template>

<script>

export default {
  props:['childdata'],
  data () {
    return {
      actionauth:'', //功能权限
      url:this.GLOBAL.domain+"Ware/index",
      transitionshow:true,
      update: {
        act:'edit',
        token:this.$cookies.get('token'),
        id:'',
        name:'',
        number:'',
        contact:'',
        phone:''
      },
      updateLoading:false,
      rules: {
        name: [
            { required: true, message: '请输入仓库名称', trigger: 'blur' },
            { min: 2, max: 20, message: '长度在 2 到 20 个字符'}
        ],
        number: [
            { required: true, message: '请输入编号', trigger: 'blur' },
            { min: 1, max: 8, message: '长度在 1 到 8 个字符'},
            { pattern:/^[A-Za-z0-9]+$/, message: '编号只能为字母和数字'}
        ]
      }
      
    }
  },
  mounted(){
    this.getactionauth();
    this.editCurrent();
  },
  methods:{
    
    /** 获取功能操作权限 **/
    getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
    
    editCurrent() {
    	var item=this.childdata;
    	this.update.id=item.id;
        this.update.name=item.name;
        this.update.number=item.number;
        this.update.contact=item.contact;
        this.update.phone=item.phone;
    },
    
    updateSave(){
      // 主动校验
      this.$refs.update.validate((valid) => {
          if (valid) {
              this.updateLoading=true;
              var resource = this.$resource(this.url);
              resource.save(this.update).then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                    this.updateLoading=false;
                  }else{
                    this.$message.success(res.data.Message);
                    this.updateLoading=false;
                    this.$emit('closechild','Warehouseedit'); //关闭窗口
                  }
              }).catch((res) => {
                  this.updateLoading=false;
              });
          }else {
            return false;
          }
      });
    },
    
    
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder3 {background:#fff;border-radius:15px;border:1px solid #ddd;float:left;width:98%;padding:1% 1% 0 1%;}
</style>


// WEBPACK FOOTER //
// src/components/inventory/Warehouseedit.vue